export const authMeta = {
  requiresAuth: true
};

export const noAuthMeta = {
  requiresAuth: false
};
